<app-capital-container>
    <div class="update-personal-data-view">
        <app-capital-back></app-capital-back>

        <h1 class="main-title">Actualiza tus datos</h1>

        @if (isLoading() || authService.isLoadingDatos()) {
            <div class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando datos...</span>
                </div>
                <p class="mt-3">Cargando tus datos...</p>
            </div>
        } @else {
        <div class="row g-4">
            <!-- Tarjeta izquierda: Formulario de datos modificables -->
            <div class="col-12 col-lg-6">
                <app-capital-card>
                    <form [formGroup]="updateForm" (ngSubmit)="onSubmit()" class="update-form">
                        <!-- Correo -->
                        <app-capital-input [placeholder]="'Correo'" [type]="'email'" formControlName="correo">
                        </app-capital-input>

                        <!-- Teléfonos -->
                        <div class="row g-3">
                            <div class="col-12 col-md-6">
                                <app-capital-input [placeholder]="'Teléfono móvil'" [type]="'tel'"
                                    formControlName="telefonoMovil">
                                </app-capital-input>
                            </div>
                            <div class="col-12 col-md-6">
                                <app-capital-input [placeholder]="'Teléfono fijo'" [type]="'tel'"
                                    formControlName="telefonoFijo">
                                </app-capital-input>
                            </div>
                        </div>

                        <!-- País y Región -->
                        <div class="row g-3">
                            <div class="col-12 col-md-6">
                                <app-capital-select [placeholder]="'País de residencia'" [options]="paises()"
                                    formControlName="paisResidencia">
                                </app-capital-select>
                            </div>
                            <div class="col-12 col-md-6">
                                <app-capital-select 
                                    [placeholder]="regionPlaceholder()" 
                                    [options]="regiones()"
                                    formControlName="region">
                                </app-capital-select>
                            </div>
                        </div>

                        <!-- Comuna y Ciudad -->
                        <div class="row g-3">
                            <div class="col-12 col-md-6">
                                <app-capital-select [placeholder]="'Comuna'" [options]="comunas()"
                                    formControlName="comuna">
                                </app-capital-select>
                            </div>
                            <div class="col-12 col-md-6">
                                <app-capital-input [placeholder]="'Ciudad'" [type]="'text'" formControlName="ciudad">
                                </app-capital-input>
                            </div>
                        </div>

                        <!-- Dirección -->
                        <app-capital-input [placeholder]="'Dirección'" [type]="'text'" formControlName="direccion">
                        </app-capital-input>

                        <!-- Mensajes de éxito/error -->
                        @if (successMessage()) {
                            <div class="alert alert-success" role="alert">
                                {{ successMessage() }}
                            </div>
                        }
                        @if (errorMessage()) {
                            <div class="alert alert-danger" role="alert">
                                {{ errorMessage() }}
                            </div>
                        }

                        <!-- Botón de envío -->
                        <app-primary-button 
                            [text]="isSaving() ? 'Guardando...' : 'Modificar datos'" 
                            [disabled]="!updateForm.valid || isSaving()">
                        </app-primary-button>
                    </form>
                </app-capital-card>
            </div>

            <!-- Tarjeta derecha: Datos personales no modificables -->
            <div class="col-12 col-lg-6">
                <app-capital-card>
                    <div class="readonly-section" [formGroup]="updateForm">
                        <div class="readonly-header">
                            <h2 class="capital-text">
                                <span class="fw-bold">Datos personales:</span>
                                <span> Esta información no es modificable por este medio.</span>
                            </h2>
                        </div>

                        <div class="readonly-data">
                            <!-- Nombre -->
                            <app-capital-input [placeholder]="'Nombre'" [type]="'text'" formControlName="nombre">
                            </app-capital-input>

                            <!-- Apellidos -->
                            <app-capital-input [placeholder]="'Apellidos'" [type]="'text'" formControlName="apellidos">
                            </app-capital-input>

                            <!-- RUT y Fecha de nacimiento -->
                            <div class="row g-3">
                                <div class="col-12 col-md-6">
                                    <app-capital-input [placeholder]="'RUT'" [type]="'text'" formControlName="rut">
                                    </app-capital-input>
                                </div>
                                <div class="col-12 col-md-6">
                                    <app-capital-input [placeholder]="'Fecha de nacimiento'" [type]="'text'"
                                        formControlName="fechaNacimiento">
                                    </app-capital-input>
                                </div>
                            </div>

                            <!-- Sexo y Estado civil -->
                            <div class="row g-3">
                                <div class="col-12 col-md-6">
                                    <app-capital-input [placeholder]="'Sexo'" [type]="'text'" formControlName="sexo">
                                    </app-capital-input>
                                </div>
                                <div class="col-12 col-md-6">
                                    <app-capital-input [placeholder]="'Estado civil'" [type]="'text'"
                                        formControlName="estadoCivil">
                                    </app-capital-input>
                                </div>
                            </div>

                            <!-- Información adicional -->
                            <div class="info-box">
                                <div class="d-flex justify-content-center align-items-center">
                                    <img src="/img/info-solid.svg" alt="" width="30px">
                                </div>
                                <p class="info-text">
                                    Comunícate con un ejecutivo para actualizar tus datos personales.
                                </p>
                            </div>
                        </div>
                    </div>
                </app-capital-card>
            </div>
        </div>
        }
    </div>
</app-capital-container>